import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import FollowupSection from "./components/FollowupSection/FollowupSection";
import FollowupForm from "./components/FollowupForm/FollowupForm";
import { useModal } from "../../context";
import { usePermissions } from "../../hooks";
import capitalizeEveryWord from "../../utils/capitalizeEveryWord";
import "./Followups.scss";
import checkMobile from "../../utils/checkForMobile";

const CompletedFollowups = ({
  followups,
  employeeNumber,
  loading,
  setFollowups,
  refetchMyFollowups,
  userData,
}) => {
  const permissionLevels = usePermissions();
  const isMobile = checkMobile();
  const [permissions, setPermissions] = useState(null);

  const showManagerReviews =
    permissions?.webEditor ||
    permissions?.superAdmin ||
    permissions?.admin ||
    permissions?.fieldSupervisor;

  const { setModalOpen } = useModal();

  const handleComplete = async () => {
    setModalOpen(false);
    await refetchMyFollowups();
  };

  const completeFollowups = followups?.filter((followup) => followup.status === "COMPLETED");

  useEffect(() => {
    if (permissionLevels) {
      setPermissions(permissionLevels);
    }
  }, [permissionLevels]);

  const handleOpenFollowup = (followup, followupIndex, isCompletedSection) => {
    setModalOpen(
      true,
      <FollowupForm
        currentFollowupId={followups?.[followupIndex]?.id}
        employeeNumber={employeeNumber}
        followup={followup}
        followups={followups}
        isCompletedSection={isCompletedSection}
        loading={loading}
        permissions={permissionLevels}
        refetchMyFollowups={refetchMyFollowups}
        onCanceled={() => setModalOpen(false)}
        onComplete={handleComplete}
      />
    );
  };

  return (
    <div
      className={
        showManagerReviews
          ? "reviews-outer-container-manager-followups"
          : "reviews-outer-container-followups"
      }
    >
      <div className="reviews-container-section">
        <div className="reviews">
          {completeFollowups.length ? (
            <React.Fragment>
              <div className="centered-title" id="employee-reviews">
                <Typography variant={isMobile ? "h4" : "h3"}>
                  {capitalizeEveryWord(
                    `${userData?.firstName} ${userData?.lastName} Completed Follow-ups`
                  )}
                </Typography>
              </div>
              <FollowupSection
                isCompletedSection
                followups={followups}
                handleClick={handleOpenFollowup}
                sectionType="personal"
                setFollowups={setFollowups}
              />
            </React.Fragment>
          ) : (
            <div className="centered-title">
              <Typography variant={isMobile ? "h4" : "h3"}>
                Nice! All your follow-ups are completed
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CompletedFollowups.propTypes = {
  followups: PropTypes.array.isRequired,
  employeeNumber: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  setFollowups: PropTypes.func.isRequired,
  refetchMyFollowups: PropTypes.func,
  userData: PropTypes.object.isRequired,
};

CompletedFollowups.defaultProps = {
  refetchMyFollowups: () => {},
};

export default CompletedFollowups; 